import type { ApiErrorShape } from "../types/app";

export function normalizeApiError(status: number, body?: unknown): ApiErrorShape {
  const upstreamCode =
    typeof body === "object" && body && "upstreamCode" in body
      ? String((body as { upstreamCode?: string }).upstreamCode)
      : "";
  const rawMessage =
    typeof body === "object" && body && "message" in body
      ? String((body as { message?: string }).message)
      : typeof body === "string"
        ? body
        : "";
  if (status === 401) return { status, code: "missing_api_key", message: "APIキーが設定されていないか、認証に失敗しました。" };
  if (status === 403) return { status, code: "origin_denied", message: "このOriginからのAPI利用は許可されていません。" };
  if (status === 413) return { status, code: "input_too_large", message: "入力文字数が上限を超えています。" };
  if (status === 429 && upstreamCode === "insufficient_quota") {
    return {
      status,
      code: "insufficient_quota",
      message: "OpenAI APIのクレジットまたはProject Budgetが不足しています。OpenAIの課金設定を確認してください。",
    };
  }
  if (status === 429) return { status, code: "rate_limited", message: "API利用上限または連続リクエスト制限に達しました。" };
  if (status >= 500) return { status, code: "server_error", message: "サーバー側でエラーが発生しました。" };
  return { status, code: "api_error", message: rawMessage || "APIエラーが発生しました。" };
}
